import React from "react";
import { Typography } from "@mui/material";
import useStyles from "./style";
import { PieChart, Pie, Sector, Cell, ResponsiveContainer, Legend, Label } from 'recharts';
import jsonUtils from "../../utils/jsonUtils";

const COLORS = ['#4C49ED', '#16325C', '#A1D4B9', '#EB9827'];

const Bullet = ({ backgroundColor, size }) => {
  const classes = useStyles();
  return (
    <div
      className={classes.circleBullet}
      style={{
        backgroundColor,
        width: "17px",
        height: "9px",
      }}
    ></div>
  );
};

const CustomizedLegend = (props) => {
  const relatorio = props.relatorio;
  const classes = useStyles();
  const { payload } = props;
  return (
    <ul className={classes.legendList}>
      {payload.map((entry, index) => (
        <li key={`item-${index}`}>
          <div className={classes.BulletLabel}>
            <Bullet backgroundColor={entry.payload.fill} size="10px" />
            <div className={classes.BulletLabelText}>{entry.value}</div>
          </div>
          <div className={classes.BulletLabelAlign}>
            <div className={classes.BulletLabelValue}>{entry.payload.formattedValue}</div>
          </div>
        </li>
      ))}
    </ul>
  );
};

const ComponentValoresConsolidados = (props) => {
  const relatorio = props.relatorio;
  const classes = useStyles();

  const avencer = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.CONSOLIDADO.CREDITO_AVENCER.VALOR", relatorio);
  const avencerNumerico = parseFloat((avencer || "0" ).replace(',', '.')) || 0;
  const avencerFormatado = avencerNumerico.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
  
  const vencido = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.CONSOLIDADO.CREDITO_VENCIDO.VALOR", relatorio);
  const vencidoNumerico = parseFloat((vencido || "0").replace(',', '.')) || 0;
  const vencidoFormatado = vencidoNumerico.toLocaleString('pt-BR',{
    style: 'currency',
    currency: 'BRL',
  });
  
  const credito = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.CONSOLIDADO.LIMITE_CREDITO.VALOR", relatorio);
  const creditoNumerico = parseFloat((credito || "0").replace(',', '.')) || 0;
  const creditoFormatado = creditoNumerico.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
  
  const prejuizo = jsonUtils.getValor("consultas.relatorio_financeiro.body.CREDCADASTRAL.RELATORIO_SCR.CONSOLIDADO.PREJUIZO.VALOR", relatorio);
  const prejuizoNumerico = parseFloat((prejuizo || "0").replace(',', '.')) || 0;
  const prejuizoFormatado = prejuizoNumerico.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  const total = (avencerNumerico + vencidoNumerico + creditoNumerico + prejuizoNumerico) || 0;
  const totalFormatado = total.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  const data = [
    { name: 'Crédito à vencer', value: avencerNumerico, formattedValue: avencerFormatado, unit: 'R$' },
    { name: 'Crédito vencido', value: vencidoNumerico, formattedValue: vencidoFormatado, unit: 'R$' },
    { name: 'Limite de crédito', value: creditoNumerico, formattedValue: creditoFormatado, unit: 'R$' },
    { name: 'Prejuízo', value: prejuizoNumerico, formattedValue: prejuizoFormatado, unit: 'R$' },
  ];

  return (
    <div className={classes.component}>
      <div >
        <div className={classes.align}>

          <Typography
            variant="h6"
            fontWeight="700"
            color="#938FA3"
            marginTop="5px"
          >
            Valor total consolidado
          </Typography>

          <Typography
            variant="h4"
            fontWeight="800"
            color="#16325C"
            marginLeft="20px">
            {totalFormatado}
          </Typography>

        </div>
        <p className={classes.parag}>Soma do valor total de todas os limites de crédito disponíveis,<br />
          contemplando valores utilizados, limites disponíveis, créditos à
          vencer<br /> e créditos já vencidos.</p>
      </div>

      <div className={classes.alignGrafico}>

        <PieChart margin={{ top: 5, right: 100, left: 20, bottom: 0 }} width={600} height={300} >
          <Pie
            data={data}
            cx={200}
            cy={85}
            innerRadius={60}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >

            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend layout="vertical" verticalAlign="top" align="right" wrapperStyle={{ marginTop: "1%", }} content={<CustomizedLegend />} />
        </PieChart>

      </div>
    </div>
  );
};

export default ComponentValoresConsolidados;
